// extracted by css-extract-rspack-plugin
export default {"label":"label-dGcS3B","item":"item-UGSUD0"};